module.exports = __webpack_public_path__ + "static/media/afterglow-back-view-dawn-2825791@2x.a2803b22.png";